<template>
	<footer>
		<div class="footer">
			<div class="footer-content">
				<div class="button-router hidden-mobile">
					<div class="button-title">{{ $t("footer.aboutHakko") }}</div>
					<div class="button-router-list">
						<div class="button-router-item" v-for="item in pageRouterList" :key="item.id" @click="handleButtonRouterClick(item)">
							<span class="button-router-item-text">{{ $t(`header.${item.nameKey}`) }}</span>
						</div>
						<div class="button-router-item" @click="handleOpenNewPage('https://www.hakko.ai/privacy.html')">
							<span class="button-router-item-text">{{ $t("header.privacyPolicy") }}</span>
						</div>
					</div>
				</div>
				<div class="co-branding hidden-mobile">
					<div class="button-title">{{ $t("footer.partners") }}</div>
					<div class="co-branding-list">
						<img src="@/assets/imgs/lenovo.png" width="81" alt="lenovo" />
						<img src="@/assets/imgs/nvidia.png" width="106" alt="nvidia" />
						<img src="@/assets/imgs/intel.png" height="34" alt="intel" />
						<img src="@/assets/imgs/amd.png" width="77" alt="amd" />
					</div>
				</div>
				<img class="hakko-logo hidden-pc" src="@/assets/imgs/icon-logo-text.webp" alt="hakko" />
				<div class="sns">
					<div class="button-title hidden-mobile">SNS</div>
					<div class="sns-list hidden-mobile">
						<img src="@/assets/imgs/x.png" alt="x" @click="handleSnsClick('x')" />
						<img src="@/assets/imgs/game.png" alt="game" @click="handleSnsClick('discord')" />
						<img src="@/assets/imgs/youtube.png" alt="youtube" @click="handleSnsClick('youtube')" />
					</div>
					<div class="mobile-route hidden-pc">
						<div class="router-item" @click="handleButtonRouterClick(pageRouterList[5])">
							<span class="router-item-text">{{ $t("header.aboutUs") }}</span>
						</div>
						<div class="router-item-divider van-hairline--right"></div>
						<div class="router-item" @click="handleOpenNewPage('https://www.hakko.ai/privacy.html')">
							<span class="router-item-text">{{ $t("header.privacyPolicy") }}</span>
						</div>
					</div>
					<div class="sns-contact">{{ $t("footer.businessCooperation") }}：market@hakko.ai</div>
					<div class="sns-list hidden-pc">
						<img src="@/assets/imgs/x.png" alt="x" @click="handleSnsClick('x')" />
						<img src="@/assets/imgs/game.png" alt="game" @click="handleSnsClick('discord')" />
						<img src="@/assets/imgs/youtube.png" alt="youtube" @click="handleSnsClick('youtube')" />
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				{{ $t("footer.copyright") }}
			</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
import { pageRouterList } from "@/utils/config";
import type { PageRouterItem } from "@/utils/config";
import { snsList } from "@/utils/config";
import { useRouter } from "vue-router";
const { locale } = useI18n();

const router = useRouter();
const { $eventBus } = useNuxtApp();

const handleButtonRouterClick = (item: PageRouterItem) => {
	$eventBus.emit("jumpTo", item);
};

const handleSnsClick = (type: string) => {
	const snsItem = snsList.value.find(item => item.nameKey === type);
	window.open(locale.value === "en" ? snsItem?.path_en : snsItem?.path, "_blank");
};

const handleOpenNewPage = (url: string) => {
	window.open(url, "_blank");
};
</script>

<style lang="scss" scoped>
/* 移动设备断点 */
$mobile-breakpoint: 768px;

.footer {
	.footer-content {
		display: flex;
		justify-content: center;
		padding-bottom: 20px;
		margin-bottom: 12px;
		.button-title {
			font-family: Source Han Sans CN;
			font-weight: 500;
			font-size: 16px;
			line-height: 16px;
			color: #ffffff;
			margin-bottom: 30px;
		}

		.button-router-list {
			height: 176px;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;

			.button-router-item {
				font-family: Source Han Sans CN;
				font-weight: 400;
				font-size: 16px;
				line-height: 16px;
				color: #ffffff80;
				margin-right: 40px;
				margin-bottom: 16px;
				.button-router-item-text {
					cursor: pointer;
				}
			}
		}

		.co-branding-list {
			height: 34px;
			width: 388px;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 22px;

			img {
				object-fit: contain;
			}
		}

		.sns-list {
			display: flex;
			align-items: center;
			gap: 14px;

			img {
				width: 24px;
				height: 24px;
				filter: brightness(0) invert(1);
				cursor: pointer;
			}
		}

		.sns-contact {
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #ffffff80;
		}
	}

	.footer-bottom {
		text-align: center;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 10px;
		line-height: 18px;
		letter-spacing: 0%;
		color: #ffffff80;
		padding-bottom: 18px;
	}
}

/* pc端样式 */
@media (min-width: $mobile-breakpoint) {
	.footer {
		width: 1920px;
		height: 343px;
		padding: 36px 0 0 0;
		background: linear-gradient(270.2deg, #5d6d86 0.06%, #a5687d 100.27%);

		.footer-content {
			display: flex;
			justify-content: center;
			gap: 120px;
			padding-bottom: 20px;
			margin-bottom: 12px;
			border-bottom: 0.5px solid #ffffff24;

			.button-title {
				font-family: Source Han Sans CN;
				font-weight: 500;
				font-size: 16px;
				line-height: 16px;
				color: #ffffff;
				margin-bottom: 30px;
			}

			.button-router-list {
				height: 176px;
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;

				.button-router-item {
					font-family: Source Han Sans CN;
					font-weight: 400;
					font-size: 16px;
					line-height: 16px;
					color: #ffffff80;
					margin-right: 40px;
					margin-bottom: 16px;
					.button-router-item-text {
						cursor: pointer;
					}
				}
			}

			.co-branding-list {
				height: 34px;
				width: 388px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				gap: 22px;

				img {
					object-fit: contain;
				}
			}

			.sns-list {
				display: flex;
				align-items: center;
				gap: 14px;

				img {
					width: 24px;
					height: 24px;
					filter: brightness(0) invert(1);
					cursor: pointer;
				}
			}

			.sns-contact {
				margin-top: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #ffffff80;
			}
		}

		.footer-bottom {
			text-align: center;
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 10px;
			line-height: 18px;
			letter-spacing: 0%;
			color: #ffffff80;
			padding-bottom: 18px;
		}
	}
}

/* 移动端样式 */
@media (max-width: $mobile-breakpoint) {
	.footer {
		width: 375px;
		height: 176px;
		padding: 20px 0 0 0;
		background: linear-gradient(270.2deg, #5d6d86 0.06%, #a5687d 100.27%);
		overflow: hidden;

		.footer-content {
			flex-direction: column;
			padding: 0 20px 10px 20px;
			.hakko-logo {
				width: 103px;
				height: 20px;
				margin: 0 auto 16px;
			}

			.button-title {
				font-size: 14px;
				margin-bottom: 15px;
			}

			.button-router-list {
				height: auto;
				flex-wrap: nowrap;

				.button-router-item {
					font-size: 14px;
					margin-bottom: 12px;
					margin-right: 20px;
				}
			}

			.co-branding-list {
				height: auto;
				width: 100%;
				margin-left: 0;
				gap: 15px;
				justify-content: center;

				img {
					height: 26px;
					width: auto;
				}
			}

			.sns-list {
				justify-content: center;
				gap: 20px;
			}

			.mobile-route {
				display: flex;
				justify-content: center;
				align-items: center;
				.router-item-divider {
					width: 1px;
					height: 10px;
					margin: 0 10px;
				}
				.router-item {
					font-weight: 400;
					font-size: 10px;
					line-height: 16px;
					color: #ffffff80;
				}
			}

			.sns-contact {
				margin: 6px 0 10px;
				text-align: center;
				font-weight: 400;
				font-size: 10px;
				line-height: 16px;
			}
		}

		.footer-bottom {
			padding: 0 28px;
			font-weight: 400;
			font-size: 6px;
			line-height: 10px;
		}
	}
}
</style>
